import React, { useEffect } from 'react';
import Document from "../common/Document";
import { hasEmployeeStatement, hasMedicalCertificationForm, hasPhysicianStatement } from "../../enums/BenefitType";
import { DocumentType } from "../../enums/DocumentType";
import RadioGroup from "../../structure/RadioGroup";
import { BeneficiaryDesignationStatus } from "../../enums/BeneficiaryDesignationStatus";
import { LifeEmployerFormValues } from "../../life/LifeEmployerFormValues";
import TextInput from "../../input/TextInput";
import EmailInput from "../../input/EmailInput";
import { PfmlEmployerFormValues } from "../../pfml/PfmlEmployerFormValues";
import { useFormikContext } from "formik";
import { DisabilityEmployerFormValues } from "../../disability/DisabilityEmployerFormValues";

const EmployerDocument = () => {
    const { initialValues, values, setFieldValue } = useFormikContext<DisabilityEmployerFormValues>();
    let documentTypeOptions = [] as DocumentType[]
    let documentDescription;

    useEffect(() => {
        if (BeneficiaryDesignationStatus.UPLOADED !== (values as any as LifeEmployerFormValues).beneficiaryDesignationStatus
            && values.documents?.some(document => [DocumentType.BENEFICIARY_DESIGNATION, DocumentType.ENROLLMENT_FORM].includes(document.documentType as DocumentType))) {
            setFieldValue('beneficiaryDesignationStatus', BeneficiaryDesignationStatus.UPLOADED);
        }
    }, [values, setFieldValue]);

    if (hasEmployeeStatement(values)) {
        documentTypeOptions.push(DocumentType.EMPLOYEE_STATEMENT)
    }
    if (hasPhysicianStatement(values)) {
        documentTypeOptions.push(DocumentType.PHYSICIAN_STATEMENT)
    }
    if (hasMedicalCertificationForm(values)) {
        documentTypeOptions.push(DocumentType.MEDICAL_CERTIFICATION_FORM)
    }
    if (values.life) {
        documentTypeOptions.push(DocumentType.BENEFICIARY_DESIGNATION, DocumentType.ENROLLMENT_FORM)
        documentDescription = <div className="flex-gap">
            <div>For the beneficiary designation, please upload one of the following:</div>
            <div>A copy of the employee's beneficiary designation for their group life insurance (maintained by you), a
                screen print of an online designation, or a prior life insurance carrier's form.</div>
        </div>
    }
    if (initialValues.baseWage !== undefined || (initialValues as any as PfmlEmployerFormValues).earningsQuarters !== undefined) {
        documentTypeOptions.push(DocumentType.EARNINGS)
    }
    return (
        <Document documentTypeOptions={documentTypeOptions}
                  documentDescription={documentDescription}
                  panelContent={
                      <>
                          <RadioGroup id="beneficiary-designation-status" label="Beneficiary designation status"
                                      required={true}
                                      radioProps={Object.keys(BeneficiaryDesignationStatus).map(beneficiaryDesignationStatus => ({
                                          id: beneficiaryDesignationStatus.replace(/_/g, '-').toLowerCase(),
                                          text: (BeneficiaryDesignationStatus as any)[beneficiaryDesignationStatus]
                                      }))}/>
                          {(values as any as LifeEmployerFormValues).beneficiaryDesignationStatus === BeneficiaryDesignationStatus.THIRD_PARTY
                              && <>
                                  <TextInput id="third-party-contact-name" label="Third party contact name" required={true}/>
                                  <EmailInput id="third-party-contact-email-address" label="Third party contact email" required={true}/>
                              </>}
                      </>
                  }/>
    )
};

export default EmployerDocument;